<template>
  <section>
    <gs-header title="Sửa danh mục bài viết"
      :breadcrumbs="[
        {title: 'Quản lý danh mục bài viết', route: {name: 'category'}}
      ]"
    >
    </gs-header>
    <div class="padding-all">
      <el-form :model="localCategory" :rules="rules" ref="editCategoryForm" label-width="200px" label-position="top" @submit.prevent.native="validateBeforeSubmitCategory('editCategoryForm')">
        <el-form-item label="Tên danh mục bài viết" prop="name">
          <el-input v-model="localCategory.name" placeholder="Tên danh mục bài viết"></el-input>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Kiểu danh mục" prop="type">
              <el-select
                class="width-100"
                v-model="localCategory.type"
                filterable
                placeholder="Kiểu danh mục"
                @change="getCategories"
                >
                <el-option
                  label="Chọn kiểu danh mục"
                  value=""
                  >

                </el-option>
                <el-option
                  v-if="categoryHelpers.types"
                  v-for="(type, key, index) in categoryHelpers.types"
                  :key="index"
                  :label="type"
                  :value="key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Chọn danh mục" prop="parent_id">
              <el-select
                class="width-100"
                v-model="localCategory.parent_id"
                filterable
                placeholder="Chọn danh mục"
                >
                <el-option
                  v-for="category in categories"
                  :key="category.id"
                  :label="category.name"
                  :value="category.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="Trạng thái" prop="active" class="is-required">
          <el-radio-group v-model="localCategory.active">
            <el-radio v-for="(status, key, index) in categoryHelpers.statuses" :key="key" class="radio" :label="key">{{status}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <button :disabled="submitting" class="ui blue basic small button" native-type="submit"><i class="fa fa-floppy-o"></i> Lưu lại</button>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>

<script>
import { editCategory, getCategory } from 'src/api/categories'
import { head } from 'lodash'
import mixins from './mixins'
export default {

  name: 'EditCategory',
  mixins: [mixins],
  methods: {
    validateBeforeSubmitCategory () {
      this.submitting = true
      this.$refs.editCategoryForm.validate(valid => {
        if (valid) {
          this.changedData = false
          editCategory(this.localCategory.id, this.localCategory).then(response => {
            switch (response.code) {
              case 200:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Sửa thành công',
                  body: 'Sửa danh mục bài viết thành công'
                })
                this.reloadGsTableAfterRedirect({name: 'category'}, 'categories')
                this.toggleLoadding(false)
                break
              case 422:
                this.submitting = false
                let er = response.data.errors
                let message = head(er[Object.keys(er)[0]])
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                })
                this.toggleLoadding(false)
                break
              default:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: 'Sửa danh mục bài viết thất bại',
                  type: 'warning'
                })
                this.toggleLoadding(false)
            }
          })
        } else {
          this.submitting = false
          this.$store.dispatch('toggleLoadding', false, {root: true})
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          })
          return false
        }
      })
    }
  },
  mounted () {
    getCategory(this.$route.params.id).then(response => {
      if (response.code === 200) {
        this.localCategory.id = response.data.id
        this.localCategory.name = response.data.name
        this.localCategory.type = response.data.type.toString()
        this.$nextTick(() => {
          if (response.data.parent_id === 0) {
            this.localCategory.parent_id = ''
          } else {
            this.localCategory.parent_id = response.data.parent_id
          }
        })
        this.localCategory.active = response.data.active.toString()
        setTimeout(() => {
          this.watching = true
        }, 100)
      } else {
        this.$router.push({name: 'category'})
        this.$store.dispatch('showNotify', {
          title: 'Không tìm thấy tài nguyên',
          body: 'Danh mục bài viết không tồn tại trên hệ thống',
          type: 'warning'
        }, {root: true})
      }
    })
  }
}
</script>

<style lang="css">
</style>




// WEBPACK FOOTER //
// EditCategory.vue?758988b2